import LabelInput from 'components/common/forms/LabelInput';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import { FormCheckMsgs } from 'types/components/form';
import { MypageInfoFormFields } from 'types/form/mypage';

const Name = () => {
  return (
    <LabelInput
      labelText="이름"
      placeholderText="이름을 입력해 주세요."
      name={MypageInfoFormFields.Name}
      required={true}
      disabled={true}
      inputStyle={{ backgroundColor: STYLES_VARIABLES.GRAY_01 }}
      rules={{
        required: '이름을 입력해 주세요.',
        pattern: {
          value: /^[a-zA-Z가-힣\s]{2,30}$/,
          message: FormCheckMsgs.InvalidInputValue,
        },
      }}
    />
  );
};

export default Name;
